import React, { Fragment, useState } from "react";
import CommonCard from "../../common/components/CommonCard";
import { Box, Typography } from "@mui/material";
import theme from "../../theme";
import { CalendarEventType } from "../../common/const";
import moment from "moment";
import ViewEventDialog from "./ViewEventDialog";
import CommonEventIcon from "../../common/components/CommonEventIcon";
import { useSelector } from "react-redux";

const Activity = ({
    getEvents,
    getAllEvents
}) => {
    const { eventList} = useSelector((state) => state.calendar);
    const [viewOpen, setViewOpen] = useState(false);
    const [viewData, setViewData] = useState(null);
    return (
        <Fragment>
            {viewOpen && (
                <ViewEventDialog
                    viewOpen={viewOpen}
                    setViewOpen={setViewOpen}
                    viewData={viewData}
                    getEvents={getEvents}
                    getAllEvents={getAllEvents}
                    eventList={eventList}
                />
            )}
            <CommonCard
                borderRadius={2}
                headerContent={
                    <Fragment>
                        <Box
                            display="flex"
                            justifyContent="space-between"
                            alignItems="center"
                            sx={{ padding: '13px' }}
                        >
                            <Box>
                                <Typography fontWeight={600}>Recent/Upcoming Activities within a week</Typography>
                                <Typography fontSize={14} color={theme.palette.background.dark}>A quick look at your schedule for the coming week.</Typography>
                            </Box>
                        </Box>
                    </Fragment>
                }
                border={`1px solid ${theme.palette.background.secondary}`}
                content={
                    <Box
                        sx={{
                            height: '28vh',
                            overflow: 'auto'
                        }}
                    >
                        {eventList.length > 0 ? eventList.map((a, index) => {
                            return (
                                <CommonCard
                                    key={index}
                                    background={theme.palette.background.main}
                                    borderRadius={2}
                                    paddingBottom="0px"
                                    padding="13px"
                                    marginTop={index === 0 ? "0px" : "10px"}
                                    content={
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            sx={{
                                                cursor: 'pointer'
                                            }}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setViewOpen(true);
                                                setViewData(a);
                                            }}
                                        >
                                            <Box
                                                display="flex"
                                                gap={1}
                                                alignItems="center"
                                            >
                                                {a.event_category === CalendarEventType.application ? (
                                                    <CommonEventIcon background="#E328AF" />
                                                ) : a.event_category === CalendarEventType.exam ? (
                                                    <CommonEventIcon background="#5DCFFF" />
                                                ) : a.event_category === CalendarEventType.task ? (
                                                    <CommonEventIcon background="#00C950" />
                                                ) : a.event_category === CalendarEventType.counselling ? (
                                                    <CommonEventIcon background="#FFAB2D" />
                                                ) : (
                                                    <CommonEventIcon background="#6A7282" />
                                                )}
                                                <Box>
                                                    <Typography fontSize={14} fontWeight="600">{a.event_title}</Typography>
                                                    <Typography fontSize={13} color={theme.palette.background.dark}>{moment.utc(a.event_start_timestamp).format('MMM DD')}</Typography>
                                                </Box>
                                            </Box>
                                            <Box>
                                                <Box
                                                    sx={{
                                                        background: a.priority === 'MEDIUM' ? '#FEF9C2' : a.priority === 'HIGH' ? '#FFE2E2' : theme.palette.success.light,
                                                        padding: '3px 15px',
                                                        marginBottom: 0.5,
                                                        borderRadius: 1,
                                                    }}
                                                >
                                                    <Typography fontSize={13} color={a.priority === 'MEDIUM' ? '#894B00' : a.priority === 'HIGH' ? 'red' : '#01875F'}>{a.priority}</Typography>
                                                </Box>
                                            </Box>
                                        </Box>
                                    }
                                />
                            )
                        }) : (
                            <Typography textAlign="center" color={theme.palette.background.dark}>No Event Found</Typography>
                        )}
                    </Box>
                }
                paddingBottom="0px"
                padding="13px"
                marginTop="15px"
            />
        </Fragment>
    )
}

export default Activity;